//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        infoform: {
            type: Object,
            default: () => ({})
        },
        isCompleteInfo:{
            type:Boolean,
            default:false,
        }
    },
    data () {
        return {
            form:{},
        }
    },
    computed:{
      
    },
    watch:{
        // infoform:{
        //     handler:function(n,o){
        //         this.form = this.infoform
        //     },
        //     immediate:true,
        // }
    },
    methods: {
        submitHandler() {
            //是否补全信息
            if(this.isCompleteInfo == true){
                this.$post(this.getStore('finUrl') + '/receipt/completReceipt',{
                    orderId:this.form.orderId,
                    entName:this.form.entName,
                    entCode:this.form.entCode,
                    entAddress:this.form.entAddress,
                    entPhone:this.form.entPhone,
                    entBankName:this.form.entBankName,
                    entBankCode:this.form.entBankCode,
                },function(data){
                    ShowMsg.call(this, '提交成功', 'success');
                    this.$emit('setCompleteInfo');
                })
            }else{
                this.$emit('setinvoiceinfo',this.form);
                this.cancleHandeler();
            }


        },
        cancleHandeler(){
            this.$emit('close');
        },
    },
    mounted: function() {
       this.form = this.infoform;
    }
}
